// Start Contact Form Functionality
// Start: Input Validation
function emailValidation(email) {
    var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
}

function phoneValidation(phone) {
    var re = /^[(]{0,1}[0-9]{3}[)]{0,1}[-\s\.]{0,1}[0-9]{3}[-\s\.]{0,1}[0-9]{4}$/;
    return re.test(phone);
}
// End: Input Validation

// Start: Send Data to API
var submitCustomerInfo = function() {
	jQuery('#form__submit').attr('disabled', true);

    // console.log("submitCustomerInfo:")
    let formFirstName = document.getElementById("form__first-name");
    let formLastName = document.getElementById("form__last-name");
    let formEmail = document.getElementById("form__email");
    let formPhone = document.getElementById("form__phone");
    let situation = document.getElementById("situation");
    let formAcknowledgement = document.getElementById("acknowledgement");
    let situationContainer = document.getElementById("select-container");
    let situationValue = situation.options[situation.selectedIndex].value;

    var vals = '';

    // Validate First Name
    var formFirstNameFlag = true;

    if (formFirstName.value == '') {
        formFirstName.classList.add("err")
        formFirstNameFlag = false;
    } else {
        formFirstName.classList.remove("err");
        formFirstNameFlag = true;
    }

    // Validate First Name
    var formLastNameFlag = true;

    if (formLastName.value == '') {
        formLastName.classList.add("err")
        formLastNameFlag = false;
    } else {
        formLastName.classList.remove("err");
        formLastNameFlag = true;
    }
    

    var formPhoneFlag = true;
    
    if (phoneValidation(formPhone.value) == false) {
        formPhone.classList.add("err")
        formPhoneFlag = false;
    } else {
        // form__phone.removeClass('err');
        formPhone.classList.remove("err")
        formPhoneFlag = true;
    }


    // var form__email = jQuery('#form__email');
    var formEmailFlag = true;

    if (emailValidation(formEmail.value) == false) {
        formEmail.classList.add("err")
        formEmailFlag = false;
    } else {
        formEmail.classList.remove("err")
        formEmailFlag = true;
    }

    // var form__situation = jQuery('#form__email');
    var situationFlag = true;

    if (situation.value == "") {
        situationContainer.classList.add("err")
        situationFlag = false;
    } else {
        situationContainer.classList.remove("err")
        situationFlag = true;
    }




	var formAcknowledgementFlag = true;

    if (formAcknowledgement.checked == false) {
        formAcknowledgement.classList.add("err")
        formAcknowledgementFlag = false;
    } else {
        formAcknowledgement.classList.remove("err");
        formAcknowledgementFlag = true;
    }





    if (getCookie("gclid") != "undefined") {
        formCustomerGclid = getCookie("gclid");
    }

    if (getCookie("gacreative") != "undefined") {
        formCustomerGaCreative = getCookie("gacreative");
    }

    if (getCookie("adgroupid") != "undefined") {
        formCustomerAdGroupId = getCookie("adgroupid");
    }

    if (getCookie("utmsrc") != "undefined") {
        formCustomerUtmSrc = getCookie("utmsrc");
    }

    if (getCookie("utmcampaign") != "undefined") {
        formCustomerUtmCampaign = getCookie("utmcampaign");
    }

    if (getCookie("utmcontent") != "undefined") {
        formCustomerUtmContent = getCookie("utmcontent");
    }

    if (getCookie("utmterm") != "undefined") {
        formCustomerUtmTerm = getCookie("utmterm");
    }

    if (getCookie("utmmed") != "undefined") {
        formCustomerUtmMed = getCookie("utmmed");
    }


    if (formFirstNameFlag  &&  formLastNameFlag  && formPhoneFlag && formEmailFlag && situationFlag && formAcknowledgementFlag) { 

		jQuery('.form-error-messaging').removeClass('active');

        let CustomerFirstName = formFirstName.value;
        let CustomerLastName = formLastName.value;
        let CustomerPhone = formPhone.value;
        let CustomerEmail = formEmail.value;
        

        vals += '{';
        vals += '"subject": ["TL2 - Website Form"],';
        vals += '"fromurl": ["' + window.location.href + '"],';
        
        // if (CustomerReferrerUrl != "") {
        //     vals += '"referralurl": ["' + CustomerReferrerUrl + '"],';
        // }
        
        vals += '"senderemail": ["noreply@formstack.com"],';
        vals += '"phone": ["' + CustomerPhone + '"],';
        vals += '"name": ["' + CustomerFirstName + ' ' + CustomerLastName + '"],';
        vals += '"email": ["' + CustomerEmail + '"],';
        vals += '"Company": ["TL2"],';
        vals += '"brandid": ["104"],';

		if (formCustomerGclid != "" && formCustomerGclid != null) {
            vals += '"gclid": ["' + formCustomerGclid + '"],';
        }

        if (formCustomerGaCreative != "" && formCustomerGaCreative != null) {
            vals += '"gacreative": ["' + formCustomerGaCreative + '"],';
        }

        if (formCustomerAdGroupId != "" && formCustomerAdGroupId != null) {
            vals += '"adgroupid": ["' + formCustomerAdGroupId + '"],';
        }

        if (formCustomerUtmSrc != "" && formCustomerUtmSrc != null) {
            vals += '"utmsrc": ["' + formCustomerUtmSrc + '"],';
        }

        if (formCustomerUtmMed != "" && formCustomerUtmMed != null) {
            vals += '"utmmed": ["' + formCustomerUtmMed + '"],';
        }

        if (formCustomerUtmCampaign != "" && formCustomerUtmCampaign != null) {
            vals += '"utmcampaign": ["' + formCustomerUtmCampaign + '"],';
        }

        if (formCustomerUtmContent != "" && formCustomerUtmContent != null) {
            vals += '"utmcontent": ["' + formCustomerUtmContent + '"],';
        }

        if (formCustomerUtmTerm != "" && formCustomerUtmTerm != null) {
            vals += '"utmterm": ["' + formCustomerUtmTerm + '"],';
        }


        vals += '"emailcontent": ["Name: ' + CustomerFirstName + ' ' + CustomerLastName + '\n' + 'Phone: ' + CustomerPhone + '\n' + 'Email: ' + CustomerEmail + '\n' + 'Situation: ' + situationValue + '"]';
        vals += '}';

        jQuery.ajax({
            method: "POST",
            // Live URL
            url: "https://api.walkeradvertising.com/api/WebHookUnbouncePost", 

            // Testing URL
            // url: "https://devapi.walkeradvertising.com/api/WebHookUnbouncePost",
            data: {
                "data.json": vals
            },
            success: function (response) {
				console.log("English Form Unbounce Webhook: " + response)
            }
            
        })

        // Save To DB

        // jQuery.ajax({
        //     method: 'post',
        //     url: '/wp-content/themes/walker-legal-brand/forms/save-to-db.php',
        //     data: {
        //         'CustomerFirstName': LeadFormData.CustomerFirstName,
        //         'CustomerLastName': LeadFormData.CustomerLastName,
        //         'CustomerPhone': LeadFormData.CustomerPhone,
        //         'CustomerEmail': LeadFormData.CustomerEmail
        //         // 'CustomerGclid': LeadFormData.CustomerGclid,
        //         // 'CustomerGaCreative': LeadFormData.CustomerGaCreative,
        //         // 'CustomerAdGroupId': LeadFormData.CustomerAdGroupId,
        //         // 'CustomerReferralUrl': LeadFormData.CustomerReferrerUrl,
        //         // 'CustomerSubmissionUrl': LeadFormData.CustomerSubmissionUrl,
        //         // 'CustomerUtmSrc': LeadFormData.CustomerUtmSrc,
        //         // 'CustomerUtmMed': LeadFormData.CustomerUtmMed,
        //         // 'CustomerUtmCampaign': LeadFormData.CustomerUtmCampaign,
        //         // 'CustomerUtmContent': LeadFormData.CustomerUtmContent,
        //         // 'CustomerUtmTerm': LeadFormData.CustomerUtmTerm,
        //     },
        //     success: function (response) {
        //         console.log("Mysql DB Entry: " + response)
        //     }
        // })


        .done(function (data) {

            // console.log("LeadFormData = " + LeadFormData)
            console.log("vals = " + vals)
            window.location.href = "/thank-you/";            
        })        

    } else {
		jQuery('#form__submit').attr('disabled', false);
		jQuery('.form-error-messaging').addClass('active');
    }

    // console.log(vals);
}
// End: Send Data to API

var formValidateNames = function formValidateNames() {
	// console.log(e);
	// e.preventDefault();

	// console.log("submitCustomerInfo:")
	let formFirstName = document.getElementById("form__first-name");
	let formLastName = document.getElementById("form__last-name");

	if (formFirstName.value == '') {
        formFirstName.classList.add("err")
        formFirstNameFlag = false;
    } else {
        formFirstName.classList.remove("err");
        formFirstNameFlag = true;
    }

    // Validate Last Name
    var formLastNameFlag = true;
    // var cur_url = window.location.href;

    if (formLastName.value == '') {
        formLastName.classList.add("err")
        formLastNameFlag = false;
    } else {
        formLastName.classList.remove("err");
        formLastNameFlag = true;
    }

	if ( formFirstNameFlag  && formLastNameFlag) {
		jQuery('.form-error-messaging').removeClass('active');
		jQuery('#form-wrapper').slick('slickNext');
	} else {
		jQuery('.form-error-messaging').addClass('active');
	};

}

var formValidateEmailPhone = function formValidateEmailPhone() {
	
    let formEmail = document.getElementById("form__email");
    let formPhone = document.getElementById("form__phone");

	var formPhoneFlag = true;
    
    if (phoneValidation(formPhone.value) == false) {
        formPhone.classList.add("err")
        formPhoneFlag = false;
    } else {
        // form__phone.removeClass('err');
        formPhone.classList.remove("err")
        formPhoneFlag = true;
    }

    // var form__email = jQuery('#form__email');
    var formEmailFlag = true;

    if (emailValidation(formEmail.value) == false) {
        formEmail.classList.add("err")
        formEmailFlag = false;
    } else {
        formEmail.classList.remove("err")
        formEmailFlag = true;
    }

	if (formEmailFlag == false) {
		jQuery('.form-error-messaging').html('Please enter a valid email address');
	}

	if ( formPhoneFlag  && formEmailFlag) {
		jQuery('.form-error-messaging').removeClass('active');
		jQuery('#form-wrapper').slick('slickNext');
	} else {
		jQuery('.form-error-messaging').html('* All Fields are Required ');
		jQuery('.form-error-messaging').addClass('active');
	};

}

// Start: Submit Button Click Action
var submitLeadForm = function() {
    console.log("Form Submitted");
    submitCustomerInfo();
    // console.log("Form Done");
};
// End: Submit Button Click Action
// End: Contact Form Functionality